import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import SettingReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/setting.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(SettingReducer, defaultState, asyncActions);
};

type ISettingContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const SettingContext = createContext<Partial<ISettingContext>>({
  state: defaultState,
}) as React.Context<ISettingContext>;

const SettingProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <SettingContext.Provider
      value={{
        ...reducer,
      }}
    >
      {children}
    </SettingContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useSettingContext = () => useContext(SettingContext);

export type IUseSettingContext = ReturnType<typeof useSettingContext>;

export { SettingContext, SettingProvider };
